<template>
  <Form
    :action-type="actionType"
    :subtitle="subtitle"
    :disabled="wasDisabled"
    :fallback-link="fallbackLink"
    :form-body="form"
    :starting-stock-balance="form.balance"
    :removal-callback="remove"
    :show-preloader="isLoadingNow"
    @on-submit="submit"
    @on-edit="setEditMode(true)"
    @on-cancel="setEditMode(false)"
  >
    <template slot="fields">
      <div class="row">
        <div class="col-lg-12">
          <div
            v-for="(value, key, index) in mainLabels"
            :key="index"
            class="col-lg-6 form-group"
          >
            <fieldset>
              <label>
                {{ value }}
                <span
                  v-if="isRequiredField(validationSchema[key])"
                  class="field__label_required"
                  >*</span
                >
              </label>
              <input
                class="form-control"
                :name="key"
                :maxlength="maxLength[key]"
                placeholder="Отсутствует"
                :disabled="actionType === 'read' || key === 'type'"
                v-model.trim="form[key]"
              />
            </fieldset>
          </div>
        </div>
      </div>
    </template>
  </Form>
</template>

<script>
import { validationMixin } from "vuelidate";
import schemas from "@/stock/validation-schemas";
import { stockComponentService } from "@/stock/api-services";

import Sublist from "@/_shared/features/form/Sublist";
import Form from "@/_shared/widgets/Form";

import { useForm, useNotification } from "@/_shared/mixins";
import { formsFields } from "@/stock/constants";

import { objectHelper } from "@/_shared/utils";
const { createCopy, createFromKeys } = objectHelper;
export default {
  mixins: [validationMixin, useForm, useNotification],
  components: {
    Form,
    Sublist,
  },
  data() {
    return {
      fallbackLink: "/stationery",
      entityName: {
        readonly: "Канцелярия",
        modify: "канцелярии",
      },
      form: createFromKeys(formsFields.stationery.labels),
    };
  },
  validations() {
    return {
      form: this.validationSchema,
    };
  },
  created() {
    const addingFields = createCopy(this.form);
    addingFields.type = "Канцелярия";
    this.setFormFields(addingFields, stockComponentService.get("stationery"));
  },
  computed: {
    maxLength() {
      return formsFields.stationery.maxlength;
    },
    validationSchema() {
      return schemas.stationery;
    },
    mainLabels() {
      const { name, type, barcode, vendor_code, stationery_subtype } =
        formsFields.stationery.labels;
      return {
        name,
        type,
        barcode,
        vendor_code,
        stationery_subtype,
      };
    },
  },
  methods: {
    async remove() {
      return await stockComponentService.remove([this.form.id], 'stationery');
    },
    async submit() {
      const callback = async () =>
        await stockComponentService[this.actionType](this.form, "stationery");
      await this.sendForm(callback);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/stock/pages/StationeryForm.vue